// extracted by mini-css-extract-plugin
module.exports = {"root":"table-body_root__K74g8"};